import { j as o } from "./atoms-v218.js";
import { PictureSkeleton as r } from "./atoms-v2729.js";
const a = ({
  aspectRatio: t,
  className: e
}) => /* @__PURE__ */ o.jsx(
  r,
  {
    $aspectRatio: t,
    "aria-hidden": "true",
    className: e,
    "data-testid": "picture-skeleton"
  }
);
export {
  a as PictureSkeleton
};
